<div class="wrap">
  <ng-container *ngIf="!isDetailsImageOpen; else detailsTemplate">
    <div *ngIf="filteredByClub" class="allClubs">
      Articles de l'acteur <b>{{clubSelected}}</b>
      <button appChangeColorTheme attribute="bgc" (click)="resetFilter()">
        <span class="textNoMobile">Etendre aux articles de tous les acteurs</span>
        <span class="textMobile">
          <fa-icon [icon]="getFaIcon('faTimes')"></fa-icon>
          Filtre
        </span>
      </button>
    </div>

    <section>
      <div class="offers">
        <ng-container *ngIf="!isLoading; else searchingTemplate">
          <ngx-simplebar class="offers_filter" *ngIf="widthScreen > 768">
            <div class="section_universe">
              <h2>Centre d'intérêt</h2>
              <form [formGroup]="searchForm">
                <div class="search-filter">
                  <input id="" type="text" matInput formControlName="search"  placeholder="Recherche"/>
                </div>
                <mat-error *ngIf="searchForm.get('search').value && searchForm.get('search').value.length < 3">
                  <span>Veuillez insérer au moins 3 caractères</span>
                </mat-error>

                <ng-container *ngIf="universeSelected === 5">
                    <div class="offers_filter_search">
                      <div appearance="outline" class="city">
                        <input id="" matInput ngx-google-places-autocomplete (onAddressChange)="getAddressSearch($event)" type="text"
                          formControlName="keyword" placeholder="Choix de la ville...">
                          <fa-icon [icon]="valueInput ? getFaIcon('faTimes') : getFaIcon('faSearch')"
                          (click)="valueInput ? resetSearch(): null"  (keypress)="valueInput ? resetSearch(): null"></fa-icon>
                      </div>
                      <div class="slider">
                        <span *ngIf="valueKM < 205">Distance : <b>{{ valueKM }} km</b></span>
                        <span *ngIf="valueKM === 205">Distance : <b>Toutes</b></span>
                        <mat-slider formControlName="slider" min="10" max="205" step="5" [value]="valueKM" (change)="getValueKM($event)" showTickMarks discrete>
                          <input id="" matSliderThumb>
                        </mat-slider>
                      </div>

                      <mat-form-field appearance="outline" class="startdate" (click)="datePicker.open()" (keypress)="datePicker.open()">
                        <mat-label>Date de début</mat-label>
                        <input id="" matInput [matDatepicker]="datePicker" formControlName="startDate" readonly>
                        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                        <mat-datepicker #datePicker disabled="false"></mat-datepicker>
                      </mat-form-field>
                    </div>
                </ng-container>

                <ng-container *ngIf="!isLoading; else elseTemplate">
                  <mat-radio-group [color]="color" aria-label="Select an option" class="univers_radio_button">
                    <ng-container *ngFor="let universe of listUniverses">
                      <div class="label_radio_button">
                        <mat-radio-button (click)="goToUniverseWithQueryParam(universe.universeKey)" (keypress)="goToUniverseWithQueryParam(universe.universeKey)" [checked]="universIsSelected(universe.universeKey)" value="{{universe.universeKey}}">
                          <span class="radioLabel">{{ universe.universeName }}</span>
                        </mat-radio-button>
                      </div>
                    </ng-container>
                  </mat-radio-group>
                </ng-container>
                <ng-template #elseTemplate>
                  <div class="loader">
                    <mat-spinner [diameter]="50"></mat-spinner>
                  </div>
                </ng-template>
              </form>
            </div>

            <ng-container>
              <div class="offers_filter_tags" *ngIf="tagsSelected.length > 0 && includedTags">

                <ng-container *ngFor="let t of tagsSelected">
                  <span class="tag" (click)="removeTag(t)" (keypress)="removeTag(t)" [style.background-color]="getValueColorTag(t)">
                    <fa-icon [icon]="getFaIcon('faTimesCircle')"></fa-icon>
                    {{t.tagName}}
                  </span>
                </ng-container>
              </div>
              <hr *ngIf="tagsSelected.length > 0">

              <div [ngClass]="{offers_filter_tags_reduce: !moreTag, offers_filter_tags_more: moreTag}" id="tags">
                <ng-container *ngFor="let t of tags">
                  <span *ngIf="isInTagSelected(t?.tagName)" class="tag" (click)="addTag(t)" (keypress)="addTag(t)"
                    [style.background-color]="getValueColorTag(t)"> {{t.tagName}} </span>
                </ng-container>

                <div class="more_tags" *ngIf="!moreTag" (click)="moreTag = true" (keypress)="moreTag = true">
                  <span appChangeColorTheme attribute="bgc">Afficher plus</span>
                </div>
              </div>
            </ng-container>
          </ngx-simplebar>

          <ngx-simplebar class="offers_content">

            <div class="load" *ngIf="!load">
              <mat-spinner [diameter]="50" [color]="color"></mat-spinner>
            </div>

            <div class="content" *ngIf="load && offers?.length">

              <mat-card *ngFor="let o of (offers | shuffle : universeSelected !== 5), let i = index" (click)="openOfferInNewTab(o.offerKey)" (keypress)="openOfferInNewTab(o.offerKey)" [id]="getIdOffer(i)"
                class="offer_start">

                <div class="image-offer-container" appIntersectionObserver (intersecting)="o.isVisible = $event">
                  <app-image-offer *ngIf="o.isVisible" [matCard]="true" [offerKey]="o.offerKey"
                    [height]="'250px'"></app-image-offer>
                </div>

                <mat-card-content>
                  <div class="photo_experience" *ngIf="o?.photoExperience">
                    <p>{{o?.photoExperience}}</p>
                  </div>
                  <div class="photo_experience_bas">
                    <div *ngIf="!o?.photoExperienceBas">
                    </div>
                    <div class="photo_experience_bas_item" *ngIf="o?.photoExperienceBas">
                      <p>{{o?.photoExperienceBas}}</p>
                    </div>
                    <div class="photo_experience_bas_item" *ngIf="o?.discipline">
                      <p>{{o?.discipline}}</p>
                    </div>
                  </div>

                  <h4><strong>{{o.offerName}}</strong></h4>

                  <div class="tags">
                    <ng-container *ngFor="let t of o?.mainTags, let i = index">
                      <div class="tag" [style.background-color]="getValueColorTag(t)">{{t.tagName}} </div>
                    </ng-container>
                  </div>
                </mat-card-content>

                <div class="btn_action" [id]="getIdOfferAdd(o.offerName)">
                  <div class="price">
                    <div *ngIf="o?.price" class="icon">
                      <fa-icon [icon]="getFaIcon('faEuroSign')" appChangeColorTheme attribute="color"></fa-icon>
                    </div>
                    <span *ngIf="o?.price"> {{o?.price}} </span>
                  </div>

                  <fa-icon [icon]="isInMyWishes(o.offerKey)" [style.color]="getColorOfHeart(o.offerKey)"
                    (click)="addOrDeleteToMyWish(o, $event); $event.stopPropagation()" (keypress)="addOrDeleteToMyWish(o, $event); $event.stopPropagation()" appChangeColorTheme
                    attribute="color">
                  </fa-icon>
                </div>
              </mat-card>
            </div>

            <p class="no_offers" *ngIf="load && !offers?.length">Il n'y a pas d'article.</p>
          </ngx-simplebar>
        </ng-container>

        <ng-template #searchingTemplate>
          <div class="load">
            <mat-spinner [diameter]="50" [color]="color"></mat-spinner>
          </div>
        </ng-template>
      </div>

    </section>
  </ng-container>

  <ng-template #detailsTemplate>
    <app-header-image-details [notice]="notice" (goBack)="goBack($event)"></app-header-image-details>
  </ng-template>

</div>
